<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Pagos</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right align-items-center">
              <li class="mr-2"><button class="btn btn-outline-primary btn-sm" @click="iniciarTutorial"><i
                    class="fas fa-question-circle"></i> Tutorial</button></li>
              <li class="breadcrumb-item active">Pagos</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3" @click="nuevoPago" data-toggle="modal" data-target="#pagoModal">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i
                class="fas fa-plus"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Pago</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header bg-navy d-flex flex-column flex-md-row align-items-md-center">
              <h3 class="card-title flex-grow-1"><i class="fas fa-list mr-2"></i>Historial de Pagos</h3>
              <div class="card-tools mt-2 mt-md-0 d-flex flex-wrap">
                <div class="dropdown mr-2">
                  <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="dropdownFiltros"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-filter mr-1"></i> Filtros
                  </button>
                  <div class="dropdown-menu dropdown-menu-right p-3" aria-labelledby="dropdownFiltros"
                    style="min-width: 250px;">
                    <div class="form-group">
                      <label class="small font-weight-bold">Método de Pago</label>
                      <select class="form-control form-control-sm" id="filtroMetodo" @click.stop>
                        <option value="">Todos</option>
                        <option value="Pago Movil">Pago Móvil</option>
                        <option value="Transferencia">Transferencia</option>
                        <option value="Punto">Punto</option>
                        <option value="Efectivo">Efectivo</option>
                        <option value="Divisa">Divisa</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label class="small font-weight-bold">Desde</label>
                      <input type="date" class="form-control form-control-sm" id="fechaDesde" @click.stop>
                    </div>
                    <div class="form-group mb-0">
                      <label class="small font-weight-bold">Hasta</label>
                      <input type="date" class="form-control form-control-sm" id="fechaHasta" @click.stop>
                    </div>
                    <div class="dropdown-divider"></div>
                    <button class="btn btn-outline-danger btn-sm btn-block" @click.stop="limpiarFiltros">
                      <i class="fas fa-eraser mr-1"></i> Limpiar Filtros
                    </button>
                  </div>
                </div>
                <div class="input-group input-group-sm" style="width: 200px;">
                  <input type="text" id="busquedaGeneral" class="form-control" placeholder="Buscar pago...">
                </div>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table id="tablaPagos" class="table table-hover table-striped dt-responsive nowrap mb-0"
                  style="width:100%">
                  <thead class="thead-light">
                    <tr class="bg-light">
                      <th>Estado</th>
                      <th>Método / Ref</th>
                      <th>Cliente</th>
                      <th>Monto ($)</th>
                      <th>Fecha</th>
                      <th>Distribución (Ventas)</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody @click="manejarClicTabla">
                    <tr v-for="pago in pagos" :key="pago.id"
                      :class="{ 'text-muted bg-light-danger': pago.estatus === 'anulado' }">
                      <td class="align-middle">
                        <span :class="pago.estatus === 'anulado' ? 'badge badge-danger' : 'badge badge-success'">
                          {{ pago.estatus.toUpperCase() }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <div class="font-weight-bold">{{ pago.metodo }}</div>
                        <small class="text-secondary">
                          <i v-if="tieneDocumento(pago)" class="fas fa-paperclip text-primary mr-1"
                            title="Posee comprobante"></i>
                          Ref: {{ pago.ref || 'N/A' }}
                        </small>
                      </td>
                      <td class="align-middle">{{ pago.cliente.nombre }}</td>
                      <td class="align-middle font-weight-bold"
                        :class="{ 'text-strikethrough': pago.estatus === 'anulado' }">
                        {{ formatMoneda(pago.monto) }}
                      </td>
                      <td class="align-middle">{{ pago.fecha }}</td>
                      <td class="align-middle">
                        <div v-if="pago.pago_ventas && pago.pago_ventas.length > 0" class="mb-2">
                          <div v-for="pv in pago.pago_ventas" :key="pv.id"
                            class="small mb-1 p-1 bg-light rounded border">
                            <i class="fas fa-file-invoice-dollar text-secondary mr-1"></i>
                            <span class="font-weight-bold">{{ pv.venta.numcontrol }}</span>
                            <span class="text-muted ml-1">({{ formatMoneda(pv.monto_aplicado) }})</span>
                          </div>
                        </div>
                        <div v-else-if="pago.estatus !== 'anulado'" class="small text-muted mb-2">
                          <i class="fas fa-info-circle mr-1"></i> Sin facturas asignadas
                        </div>
                        <div v-if="pago.estatus !== 'anulado'">
                          <template v-if="saldoPendiente(pago) >= 0.01">
                            <div class="text-orange small font-weight-bold">
                              <i class="fas fa-coins mr-1"></i> Disponible: {{ formatMoneda(saldoPendiente(pago)) }}
                            </div>
                            <button class="btn btn-xs btn-block btn-outline-primary mt-1 shadow-sm accion-asignar"
                              :data-pago-id="pago.id" data-toggle="modal" data-target="#pagoAsignacionModal">
                              <i class="fas fa-plus-circle mr-1"></i> Asignar a Factura
                            </button>
                          </template>
                          <template v-else>
                            <div class="badge badge-success w-100 py-1">
                              <i class="fas fa-check-double mr-1"></i> Totalmente Asignado
                            </div>
                          </template>
                        </div>
                        <span v-else class="small text-danger italic font-weight-bold">
                          <i class="fas fa-history mr-1"></i> Movimientos Revertidos
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <button class="btn btn-info btn-sm shadow-sm accion-ver" :data-pago-id="pago.id"
                          data-toggle="modal" data-target="#pagoModal">
                          <i class="fas fa-eye mr-1"></i> Ver Ficha
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Integración del modal de pagos -->
    <pago-modal :pago="pagoSeleccionado" @cerrar="cerrarModal" />
    <pago-venta-modal v-if="pagoSeleccionado.id" :pago="pagoSeleccionado" @guardado="asignacionGuardada"
      @cerrar="cerrarModal" />
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import PagoModal from './PagoModal.vue';
import PagoVentaModal from './PagoVentaModal.vue';
import 'datatables.net-bs4';
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import { tutorial } from "@/plugins/tutorial";

export default {
  components: { PagoModal, PagoVentaModal },
  setup() {
    const { proxy } = getCurrentInstance();
    const dt = ref(null);
    const pagos = ref([]);
    const pagoSeleccionado = ref({});

    async function obtenerPagos() {
      try {
        const resp = await api.get("/pagos");

        if (window.$.fn.DataTable.isDataTable('#tablaPagos')) {
          window.$("#tablaPagos").DataTable().destroy();
        }

        pagos.value = resp.data;
        await nextTick();

        // Configurar filtro de rango de fecha para DataTables
        window.$.fn.dataTable.ext.search.push(
          function (settings, data, dataIndex) {
            const desde = window.$('#fechaDesde').val();
            const hasta = window.$('#fechaHasta').val();
            const fechaPago = data[4]; // Índice de la columna Fecha

            if (!desde && !hasta) return true;
            if (!desde && fechaPago <= hasta) return true;
            if (!hasta && fechaPago >= desde) return true;
            if (fechaPago >= desde && fechaPago <= hasta) return true;
            return false;
          }
        );

        dt.value = window.$("#tablaPagos").DataTable({
          responsive: true,
          autoWidth: false,
          destroy: true,
          columnDefs: [
            { responsivePriority: -1, targets: 1 },
            { responsivePriority: -1, targets: 2 },
            { responsivePriority: -1, targets: 4 },
            { orderable: false, targets: 6 }
          ],
          pageLength: 10,
          lengthChange: false,
          pagingType: "simple_numbers",
          language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
          },
          order: [[4, "desc"]],
          dom: 't<"d-flex justify-content-between align-items-center p-3"ip>',
        });

        // Vincular filtros personalizados
        window.$('#busquedaGeneral').on('keyup', function () {
          dt.value.search(this.value).draw();
        });

        window.$('#filtroMetodo').on('change', function () {
          dt.value.column(1).search(this.value).draw();
        });

        window.$('#fechaDesde, #fechaHasta').on('change', function () {
          dt.value.draw();
        });

        window.$('#filtroFechaMobile').on('change', function () {
          dt.value.column(4).search(this.value).draw(); // Mantiene compatibilidad mobile simple
        });

      } catch (e) {
        console.error("Error al sincronizar pagos:", e);
      }
    }

    function nuevoPago() {
      pagoSeleccionado.value = {};
    }

    function verPago(pago) {
      pagoSeleccionado.value = pago;
    }

    function actualizarPago() {
      obtenerPagos();
    }

    function asignarVentas(pago) {
      pagoSeleccionado.value = pago;
    }

    function asignacionGuardada(asignacion) {
      proxy.$toast({ icon: 'success', title: 'Asignación guardada' });
      obtenerPagos();
    }

    function cerrarModal() {
      nextTick(() => {
        pagoSeleccionado.value = {};
        obtenerPagos();
      });
    }

    function limpiarFiltros() {
      window.$('#filtroMetodo').val('').trigger('change');
      window.$('#fechaDesde').val('').trigger('change');
      window.$('#fechaHasta').val('').trigger('change');
      window.$('#busquedaGeneral').val('');
      dt.value.search('').columns().search('').draw();
      proxy.$toast({ icon: 'info', title: 'Filtros restablecidos' });
    }

    function saldoPendiente(pago) {
      if (!pago || !pago.monto || pago.estatus === 'anulado') return 0;
      const totalAsignado = (pago.pago_ventas || []).reduce((acum, pv) => {
        return acum + parseFloat(pv.monto_aplicado || 0);
      }, 0);
      const montoTotal = parseFloat(pago.monto);
      const resultado = montoTotal - totalAsignado;
      return Math.max(0, parseFloat(resultado.toFixed(2)));
    }

    function formatMoneda(valor) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(valor);
    }

    function tieneDocumento(pago) {
      return pago.documentos && pago.documentos.length > 0;
    }

    function manejarClicTabla(evento) {
      const boton = evento.target.closest('[data-pago-id]');
      if (!boton) return;

      const pagoId = parseInt(boton.getAttribute('data-pago-id'));
      const pago = pagos.value.find(p => p.id === pagoId);

      if (pago) {
        if (boton.classList.contains('accion-asignar')) asignarVentas(pago);
        if (boton.classList.contains('accion-ver')) verPago(pago);
      }
    }

    function iniciarTutorial() {
      const steps = [
        {
          element: '.info-box',
          title: 'Nuevo Pago',
          text: 'Haz clic aquí para registrar un nuevo pago recibido.',
          position: 'bottom'
        },
        {
          element: '#tablaPagos',
          title: 'Lista de Pagos',
          text: 'Aquí puedes ver todos los pagos y su estado de asignación a ventas.',
          position: 'top'
        },
        {
          element: '.btn-warning',
          title: 'Detalles',
          text: 'Usa este botón para ver los detalles completos de un pago específico.',
          position: 'left'
        }
      ];
      tutorial.start(steps);
    }

    onMounted(() => {
      obtenerPagos();
      tutorial.set(iniciarTutorial);
      window.addEventListener('resize', () => {
        if (dt.value) dt.value.columns.adjust().responsive.recalc();
      });
    });

    onBeforeUnmount(() => {
      if (dt.value) dt.value.destroy();
      window.$.fn.dataTable.ext.search.pop(); // Limpiar el filtro global al salir
      tutorial.set(null);
    });

    return {
      pagos,
      pagoSeleccionado,
      obtenerPagos,
      nuevoPago,
      verPago,
      actualizarPago,
      asignarVentas,
      asignacionGuardada,
      cerrarModal,
      saldoPendiente,
      formatMoneda,
      tieneDocumento,
      limpiarFiltros,
      manejarClicTabla
    };
  }
};
</script>

<style>
.hide-next-btn .introjs-nextbutton {
  display: none !important;
}
</style>